<template>
    <div class="sellerPickerHolder">
        <multiselect :class="[size]" v-model="selectedSeller" :options="options2" :allowEmpty="allowEmpty" :multiple="false" group-values="people" :showLabels="false" group-label="groupName" :placeholder="placeholder" track-by="id" label="brandName" @input="update" @remove="remove" open-direction="bottom">
            <span slot="noResult">No results.</span>
                <!-- Selected option -->
                <template slot="singleLabel" slot-scope="props">
                    <div class="option__desc d-flex flex-row align-items-center">
                        <span class="flexGrow1">{{props.option.brandName}}</span>
                        <span v-if="props.option.channelClosed && props.option.channelClosed == true" class="customTag bg-light dark fs-smaller px-2 radius-normal">Closed</span>
                    </div>
                </template>

                <!-- Option on list -->
                <template slot="option" slot-scope="props">
                    <div class="option__desc d-flex flex-row align-items-center">
                        <span class="flexGrow1">{{props.option.brandName? props.option.brandName : props.option.$groupLabel }}</span>
                        <span v-if="props.option.channelClosed && props.option.channelClosed == true" class="customTag bg-light dark fs-smaller px-2 py-1 radius-normal">Closed</span>
                        <span v-if="props.option.protocolStatus && props.option.protocolStatus == 5" class="customTag bg-light dark fs-smaller px-2 py-1 radius-normal">Blocked</span>
                    </div>
                </template>


        </multiselect>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
 import Multiselect from 'vue-multiselect'

export default {
    data: function() {
        return {
            options: [
                {
                    groupName: 'My Team',
                    people: []
                },
                {
                    groupName: 'Agents',
                    people: []
                }
            ],
            selectedOption: null,
            myTeamArr: null,
            agentsArr: null,
        }
    },
    props:{
        size: {
            type: String,
            default: 'normal'
        },
        reservation: {
            // this is not mandatory, this component can be used without a reservation
            // for that just use the @input event to get the selected seller
            // if a reservation is provided the component will update the that reservation
            default:null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        orignalSeller: {
            default: null
        },
        agentList: {
            default: null
        },
        myTeamList: {
            default: null
        },
        inlcudeWidget:{
            default: false
        },
        allowEmpty: {
            type: Boolean,
            default: false,
        },
        showMyTeam: {
            type: Boolean,
            default: true
        },
        changeReservationSeller: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: 'Selecte one'
        }
    },
    created: function() {
        let vm = this
        // this.downloadAgents(this.agentList)
        // this.downloadTeam(this.myTeamList)
        //
        // this.downloadTeam()
        // this.downloadAgents()

        let downloads = async () => {
            if(this.showMyTeam == true){
                await this.downloadTeam()
            }
            await this.downloadAgents()
        }

        downloads().then(r => {
            vm.$emit('allDownloaded')
            return true
        })

        this.addWidget()

    },
    computed: {
        ...mapGetters([
            'account',
            'getTeam',
            'getAgents',
            'getActiveIntegrations',
            'getSalesChannels'
        ]),
        allAgents: function () {
            let output
            if(this.agentList){
                output = this.agentList
            } else {
                output = this.getAgents
            }

            return output.filter(agent => {return !agent.isOTA})
        },
        selectedSeller: {
            // getter
            get: function () {
                if(this.selectedOption){
                    return this.selectedOption
                } else if(this.orignalSeller) {
                    let output = this.orignalSeller
                    if(!output.brandName){
                        this.$set(output, 'brandName', output.name)
                    }
                    return output
                } else {
                    return ''
                }
            },
            // setter
            set: function (newValue) {
                  this.selectedOption = newValue
            }
        },
        options2: function () {
            let outputArr = []

            if(this.allowEmpty){
                outputArr.push({
                    groupName: 'All Sellers',
                    people: [
                        {
                            brandName:'All Sellers',
                            value: 0,
                            isAllSellers: true
                        }
                    ]
                })
            }

            if(this.showMyTeam){
                let myTeamPeople
                if(this.myTeamList){
                    // outputArr.push({
                    //     groupName: 'My Team',
                    //     people: this.myTeamList
                    // })
                    myTeamPeople = this.myTeamList
                } else {
                    let teamArr = JSON.parse(JSON.stringify(this.getTeam))
                    teamArr.map(teamMember => {
                        teamMember.brandName = teamMember.name
                    })
                    myTeamPeople = teamArr

                    // outputArr.push({
                    //     groupName: 'My Team',
                    //     people: teamArr
                    // })
                }

                // create a group for each custom sales channel
                for (let person of myTeamPeople) {
                  // find if group exists
                  var groupFound = outputArr.find(outputGroup => {return outputGroup.groupName == person.salesChannel.brandName})

                    if(groupFound == undefined){
                        // createGroup
                        outputArr.push({
                            groupName: person.salesChannel.brandName,
                            people: [person]
                        })
                    } else {
                        groupFound.people.push(person)
                    }
                }

            }

            outputArr.push({
                groupName: 'Agents',
                people: this.allAgents
            })

            // if(this.inlcudeWidget){
                // testing using sales channels directly
                // let otherSellers = this.getSalesChannels

                // let otherSellers = [
                //     {
                //         brandName:'Widget',
                //         value: 0,
                //         isWidget: true
                //     },
                //     {
                //         brandName:'Pluralo Locals',
                //         value: 0,
                //         isPluralLocals: true
                //     },
                // ]

                let otherSellers = []

                // Add "Widget"
                if(this.inlcudeWidget){
                    otherSellers.push(this.getSalesChannels.find(channel => channel.channelType == 101))
                }

                // Add "Pluralo Locals"
                otherSellers.push(this.getSalesChannels.find(channel => channel.channelType == 201))


                // Have integration with Get Your Guide?
                if(this.getActiveIntegrations.getYourGuide){
                    // otherSellers.push({
                    //     brandName:'Get Your Guide',
                    //     value: 0,
                    //     isGetYourGuide: true
                    // })

                    // Add "Get Your Guide"
                    otherSellers.push(this.getSalesChannels.find(channel => channel.channelType == 202))
                }


                outputArr.push({
                    groupName: 'Others',
                    people: otherSellers
                })
            // }

            return outputArr
        }
    },
    methods: {
        ...mapActions([
            'downloadTeam',
            'downloadAgents'
        ]),
        downloadAgents: function(propAgentList) {
            if(propAgentList == null){
                // axios.get('/api/people/GetAssociatedAgents', {
                //     params: {
                //         supplierId: this.account.supplierId
                //     }
                // }).then(response => {
                //     if(response.status == 200){
                //         this.agentsArr = response.data
                //         this.$set(this.options[1], 'people', response.data)
                //     }
                // })
                // this.$set(this.options[1], 'people', this.getAgents)
                this.options[1].people = this.getAgents
            } else {
                this.$set(this.options[1], 'people', propAgentList)
            }
        },
        // downloadTeam: function(propMyTeam) {
        //     if(propMyTeam == null){
        //         axios.get('/api/supplier/memberList', {
        //             params: {
        //                 supplierId: this.account.supplierId
        //             }
        //         }).then(response => {
        //             if(response.status == 200){
        //                 this.myTeamArr = response.data
        //                 this.$set(this.options[0], 'people', this.myTeamAddBrandName(response.data))
        //             }
        //         })
        //     } else {
        //         this.$set(this.options[0], 'people', this.myTeamAddBrandName(propMyTeam))
        //     }
        // },
        addWidget: function () {

            let peopleToAdd = []
            // Add "Widget"
            if(this.inlcudeWidget){
                peopleToAdd.push(this.getSalesChannels.find(channel => channel.channelType == 101))
            }
            // Add "Pluralo Locals"
            peopleToAdd.push(this.getSalesChannels.find(channel => channel.channelType == 201))
            // Add "Get Your Guide"
            peopleToAdd.push(this.getSalesChannels.find(channel => channel.channelType == 202))


            this.options.push({
                groupName: 'Others',
                people: peopleToAdd
            })


        },
        update: function(value) {
            if(value){
                this.$emit('input', value)
                if(this.reservation && this.changeReservationSeller){
                    this.updateReservation(value)
                }
            }
        },
        updateReservation: function(newSeller){
            if(newSeller.commission){
                //is an agent
                this.reservation.creatorAgent = newSeller
                this.reservation.creatorUserAccount = this.account
                this.reservation.creatorSupplier = null
            } else {
                //is my team
                this.reservation.creatorAgent = null
                this.reservation.creatorUserAccount = newSeller
                this.reservation.creatorSupplier = this.account.supplier
            }
        },
        myTeamAddBrandName: function(inputArr){
            inputArr.map(row => {
                row.brandName = row.name
            })

            return inputArr
        },
        remove: function() {
            this.$emit('deselect')
        },
        deselectSeller: function() {
            this.selectedSeller = ""
        }
    },
    components: {
        Multiselect
    }
}
</script>

<style lang="scss" scoped>
    .sellerPickerHolder{
        position: relative;
        z-index: 10;

        .multiselect__select{
            top:  8px !important;
        }

        .multiselect__tags{
            background: none !important;
            border: 0 !important;
        }
    }
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// SellerPicker.vue?8606d0fc